export class BaseProgressionStrategy {
  triad(ctx, deg) {
    const s = ctx.scale;
    const len = s.length;
    const r = s[deg % len] + Math.floor(deg / len) * 12;
    const third = s[(deg + 2) % len] + Math.floor((deg + 2) / len) * 12;
    const fifth = s[(deg + 4) % len] + Math.floor((deg + 4) / len) * 12;
    return [r, third, fifth];
  }

  seventh(ctx, deg) {
    const t = this.triad(ctx, deg);
    const s = ctx.scale;
    const len = s.length;
    const sev = s[(deg + 6) % len] + Math.floor((deg + 6) / len) * 12;
    return [...t, sev];
  }

  pick(ctx, options) {
    return options[Math.floor(ctx.rand() * options.length)];
  }
}
